function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Canvas",
  transform: "translate(-2546 -2023)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group 142"
}, /*#__PURE__*/React.createElement("g", {
  id: "Ellipse 45"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#plus_crcl_blue_path0_fill",
  transform: "translate(2546 2023)",
  fill: "#4D9ADF"
})), /*#__PURE__*/React.createElement("g", {
  id: "plus1"
}, /*#__PURE__*/React.createElement("g", {
  id: "Path 71"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#plus_crcl_blue_path1_fill",
  transform: "translate(2555.31 2033)",
  fill: "#FFFFFF"
})))));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "plus_crcl_blue_path0_fill",
  d: "M 20 40C 31.0457 40 40 31.0457 40 20C 40 8.9543 31.0457 0 20 0C 8.9543 0 0 8.9543 0 20C 0 31.0457 8.9543 40 20 40Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "plus_crcl_blue_path1_fill",
  d: "M 20.5891 9.487L 11.489 9.487L 11.489 0.787003C 11.489 0.578277 11.4061 0.378106 11.2585 0.230515C 11.111 0.0829234 10.9108 -1.42109e-14 10.702 0C 10.4933 -1.42109e-14 10.2931 0.0829234 10.1456 0.230515C 9.99796 0.378106 9.91506 0.578277 9.91506 0.787003L 9.91506 9.479L 0.81505 9.479C 0.709405 9.47524 0.604084 9.49278 0.505372 9.53061C 0.406661 9.56844 0.31658 9.62577 0.24051 9.69917C 0.164441 9.77258 0.103946 9.86055 0.0626234 9.95786C 0.0213006 10.0552 1.33466e-06 10.1598 1.33466e-06 10.2655C 1.33466e-06 10.3712 0.0213006 10.4758 0.0626234 10.5731C 0.103946 10.6704 0.164441 10.7584 0.24051 10.8318C 0.31658 10.9052 0.406661 10.9626 0.505372 11.0004C 0.604084 11.0382 0.709405 11.0558 0.81505 11.052L 9.90704 11.052L 9.90704 20.547C 9.90704 20.7557 9.98997 20.9559 10.1376 21.1035C 10.2852 21.2511 10.4853 21.334 10.694 21.334C 10.9028 21.334 11.1029 21.2511 11.2505 21.1035C 11.3981 20.9559 11.481 20.7557 11.481 20.547L 11.481 11.06L 20.573 11.06C 20.7817 11.0597 20.9817 10.9767 21.1292 10.8292C 21.2768 10.6817 21.3598 10.4816 21.36 10.273C 21.3629 10.1703 21.345 10.068 21.3074 9.9724C 21.2699 9.87675 21.2134 9.78964 21.1415 9.71628C 21.0695 9.64292 20.9835 9.5848 20.8886 9.54541C 20.7937 9.50602 20.6918 9.48615 20.5891 9.487Z"
}));

function SvgPluscircleblue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPluscircleblue);
export default __webpack_public_path__ + "static/media/pluscircleblue.d4d1c0e0.svg";
export { ForwardRef as ReactComponent };